import get from 'lodash/get';
import { createSelector } from 'reselect';
import { selectOneProduct } from '../../selectors';
export const selectRenewInfos = createSelector(selectOneProduct, product => get(product, 'renew'));
export const selectRenewDurations = createSelector(selectOneProduct, product => get(product, 'renew.durations', []));
export const selectHasRenewDurations = createSelector(selectRenewDurations, durations => Array.isArray(durations) && durations.length > 0);